import { ReadmissionF2fPayload } from "../readmission-f2f-types";
import { UseNotePayload, useNotePayload } from "./use-note-payload";

export const createDefaultReadmissionPayload = (): ReadmissionF2fPayload => ({
  chiefComplaints: "",
  historyOfPresentIllness: "",
  hospitalization: {},
  hospitalizationFreeText: "",
  socialHistory: {},
  allergyFreeText: "",
  pharmacies: [],
  medicationFreeText: "",
  lastPcpVisitAndLabs: {},
  lastPcpVisitFreeText: "",
  currentMedicalSpecialist: {},
  currentMedicalSpecialistFreeText: "",
  reviewOfSystems: {},
  vitalSigns: {},
  vitalSignsFreeText: "",
  physicalExam: {},
  sectionFreeText: {},
  expandedSections: {},
});

export type UseReadmissionNote = UseNotePayload<ReadmissionF2fPayload>;

export const useReadmissionNote = (
  initial: ReadmissionF2fPayload | undefined,
  sectionKeys: string[]
): UseReadmissionNote =>
  useNotePayload<ReadmissionF2fPayload>(
    () => initial ?? createDefaultReadmissionPayload(),
    sectionKeys
  );
